import { createTheme, Theme } from '@mui/material/styles';
import colors from "../colors";

const theme = createTheme({
    typography: {
        // @ts-ignore
        useNextVariants: true
    },
    palette: {
        mode: "dark",
      
    },

});

export default theme;
